import { IndicatorConfiguration } from '~/configs/indicators/aura-indicators.model';
import i18n from '~/i18n';

export enum AuraIndicator {
    // Values
    CO2 = 'CO2',
    CO2_alarm = 'CO2_alarm',
    CO2_aqi = 'CO2_aqi',
    soc = 'SOC',
    aqi = 'aqi',
    humidity = 'humidity',
    mslPressure = 'mslPressure',
    pressure = 'pressure',
    temperature = 'temperature',

    // raw values
    CO2_error = 'CO2_error',
    battery = 'battery',
    gateway_count = 'gateway_count',
    message_count = 'message_count',
    rssi = 'rssi',
    snr = 'snr',
    spreading_factor = 'spreading_factor',
}

export const indicatorsConfiguration: IndicatorConfiguration[] = [
    {
        key: AuraIndicator.CO2,
        description: i18n.global.t('indicators.CO2.description'),
        label: i18n.global.t('indicators.CO2.label'),
        unit: i18n.global.t('indicators.CO2.unit'),
        priority: 1,
        hide: false,
    },
    {
        key: AuraIndicator.CO2_alarm,
        description: i18n.global.t('indicators.CO2_alarm.description'),
        label: i18n.global.t('indicators.CO2_alarm.label'),
        unit: i18n.global.t('indicators.CO2.unit'),
        priority: 2,
        hide: false,
    },
    {
        key: AuraIndicator.CO2_aqi,
        description: i18n.global.t('indicators.CO2_aqi.description'),
        label: i18n.global.t('indicators.CO2_aqi.label'),
        unit: '',
        priority: 0,
        hide: true,
    },
    {
        key: AuraIndicator.soc,
        description: i18n.global.t('indicators.soc.description'),
        label: i18n.global.t('indicators.soc.label'),
        unit: i18n.global.t('indicators.soc.unit'),
        priority: 11,
        hide: false,
    },
    {
        key: AuraIndicator.aqi,
        description: i18n.global.t('indicators.aqi.description'),
        label: i18n.global.t('indicators.aqi.label'),
        unit: '',
        priority: 0,
        hide: true,
    },
    {
        key: AuraIndicator.humidity,
        description: i18n.global.t('indicators.humidity.description'),
        label: i18n.global.t('indicators.humidity.label'),
        unit: i18n.global.t('indicators.humidity.unit'),
        priority: 4,
        hide: false,
    },
    {
        key: AuraIndicator.mslPressure,
        description: i18n.global.t('indicators.mslPressure.description'),
        label: i18n.global.t('indicators.mslPressure.label'),
        unit: i18n.global.t('indicators.mslPressure.unit'),
        priority: 0,
        hide: true,
    },
    {
        key: AuraIndicator.pressure,
        description: i18n.global.t('indicators.pressure.description'),
        label: i18n.global.t('indicators.pressure.label'),
        unit: i18n.global.t('indicators.mslPressure.unit'),
        priority: 5,
        hide: false,
    },
    {
        key: AuraIndicator.temperature,
        description: i18n.global.t('indicators.temperature.description'),
        label: i18n.global.t('indicators.temperature.label'),
        unit: i18n.global.t('indicators.temperature.unit'),
        priority: 3,
        hide: false,
    },
    {
        key: AuraIndicator.CO2_error,
        description: i18n.global.t('indicators.CO2_error.description'),
        label: i18n.global.t('indicators.CO2_error.label'),
        unit: i18n.global.t('indicators.CO2_error.unit'),
        priority: 0,
        hide: true,
    },
    {
        key: AuraIndicator.battery,
        description: i18n.global.t('indicators.battery.description'),
        label: i18n.global.t('indicators.battery.label'),
        unit: i18n.global.t('indicators.battery.unit'),
        priority: 0,
        hide: true,
    },
    {
        key: AuraIndicator.gateway_count,
        description: i18n.global.t('indicators.gateway_count.description'),
        label: i18n.global.t('indicators.gateway_count.label'),
        unit: i18n.global.t('indicators.gateway_count.unit'),
        priority: 8,
        hide: false,
    },
    {
        key: AuraIndicator.message_count,
        description: i18n.global.t('indicators.message_count.description'),
        label: i18n.global.t('indicators.message_count.label'),
        unit: i18n.global.t('indicators.message_count.unit'),
        priority: 9,
        hide: false,
    },
    {
        key: AuraIndicator.rssi,
        description: i18n.global.t('indicators.rssi.description'),
        label: i18n.global.t('indicators.rssi.label'),
        unit: i18n.global.t('indicators.rssi.unit'),
        priority: 6,
        hide: false,
    },
    {
        key: AuraIndicator.snr,
        description: i18n.global.t('indicators.snr.description'),
        label: i18n.global.t('indicators.snr.label'),
        unit: i18n.global.t('indicators.snr.unit'),
        priority: 7,
        hide: false,
    },
    {
        key: AuraIndicator.spreading_factor,
        description: i18n.global.t('indicators.spreading_factor.description'),
        label: i18n.global.t('indicators.spreading_factor.label'),
        unit: '',
        priority: 10,
        hide: false,
    },
];


